import React, { useState } from 'react';
import MyAccount from './MyAccount';
import MyStudio from './MyStudio';
import Security from './Security';

export default function MyProfile() {
    const [activeTab, setActiveTab] = useState('account');

    const renderTabContent = () => {
        switch (activeTab) {
            case 'account':
                return <MyAccount />;
            case 'studio':
                return <MyStudio />;
            case 'security':
                return <Security />;
            default:
                return null;
        }
    };

    return (
        <div>
            <div className="bg-white p-5">
                <h1 className="text-[#0F1113] text-[20px] sm:text-[24px] font-semibold mb-4">Profile</h1>

                <div className="border-b border-gray-200">
                    <nav className="-mb-px flex space-x-8 overflow-x-auto">
                        <button
                            onClick={() => setActiveTab('account')}
                            className={`py-2 whitespace-nowrap px-1 text-sm font-medium border-b-2 ${activeTab === 'account'
                                ? 'border-red-500 text-red-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            My Account
                        </button>
                        <button
                            onClick={() => setActiveTab('studio')}
                            className={`py-2 whitespace-nowrap px-1 text-sm font-medium border-b-2 ${activeTab === 'studio'
                                ? 'border-red-500 text-red-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            My Studio
                        </button>
                        <button
                            onClick={() => setActiveTab('security')}
                            className={`py-2 whitespace-nowrap px-1 text-sm font-medium border-b-2 ${activeTab === 'security'
                                ? 'border-red-500 text-red-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            Security
                        </button>
                    </nav>
                </div>
            </div>
            <div className="pt-0 pb-5 md:px-5 px-3 py-2 bg-white">{renderTabContent()}</div>
        </div>
    );
}